// #region Base URL Configuration
export const base_url = window.APP_CONFIG?.BASE_URL || "https://localhost:7229";
// export const ExportPdfUrl = 'http://pdfgenerator.msisolutions.co.uk/form';
export const RedirectUri = window.location.origin;
// #endregion



// #region INTEGRATIONS
export const GetGisTokenData = base_url + "/api/Integration/GetGisToken";
// #endregion

// #region CONSTANTS
export const SelectedCompany = "selectedCompany";
export const CurrentWorkflowStep = "currentWorkflowStep";
export const SystemPropertiesTableName = "system_properties";
export const AccessTokenKeyInLocalStorage = "accessToken";
export const SuccessStatus = 1;
export const FailureStatus = 0;
export const LogoutStatus = -1;
// #endregion

// #region PUBLIC
export const GetDomainDataEndPoint = base_url + "/api/public/domain";
export const GetLabelsData = base_url + "/api/public/labels";
export const GetServicesData = base_url + "/api/public/services";
export const GetUserManualsData = base_url + "/api/public/user-manuals";
// #endregion

// #region DATABASE
export const GetEndPoint = base_url + "/api/Supabase/single";
export const GetAllEndPoint = base_url + "/api/Supabase/all";
export const PatchEndPoint = base_url + "/api/Supabase";
export const PutEndPoint = base_url + "/api/Supabase";
export const PostEndPoint = base_url + "/api/Supabase";
export const DeleteDBEndPoint = base_url + "/api/Supabase";
// #endregion

// #region COMPANIES
export const GetCompanyRolesData = base_url + "/api/Companies/roles";
export const GetUserCompaniesData = base_url + "/api/Companies/user";
export const GetBranchesCompanyEndPoint = base_url + "/api/Companies/branches";
// #endregion

// #region AUTHORIZATION
export const GetAccessDataEndPoint = base_url + "/api/Authorization/access-data";
export const GetAuthzCompaniesEndPoint = base_url + "/api/Authorization/companies";
export const GetCompanyRoleCatalogEndPoint = base_url + "/api/Authorization/companies";
export const GetAuthzPublicMenuEndPoint = base_url + "/api/Authorization/public-menu";
export const GetCompanyWorkflowsEndPoint = base_url + "/api/Authorization/companies"; // + /{companyId}/workflows
// #endregion

// #region USERS
// Manage Users on the authz tables: {CompanyUsersEndPoint}/{companyId}/users ...
export const CompanyUsersEndPoint = base_url + "/api/CompanyUsers";
// Field definitions of app forms (tbl_form_field_configs) for the token's application: {FormFieldsEndPoint}/{formKey}
export const FormFieldsEndPoint = base_url + "/api/FormFields";
// Old user endpoints, still used by ManageCompanyContactsPage (add) and ManageBranchesPage (unassign).
export const AddUserData = base_url + "/api/Users/company";
export const UnassignUserData = base_url + "/api/Users";
// #endregion

// #region GENERATORS
export const GetTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
export const DeleteTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const AddTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const EditTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
// #endregion

// #region CONTACTS/DELEGATES
export const AddTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const EditTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const DeleteTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const GetTransporterContactsData = base_url + "/api/WasteManagement/contacts";
// #endregion

// #region TRUCKS
export const GetTransporterTrucksData = base_url + "/api/WasteManagement/trucks";
export const AddTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const DeleteTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const EditTransporterTruckData = base_url + "/api/WasteManagement/trucks";
// #endregion

// #region MOC
export const GetCRDetails = base_url + "/api/Integration/cr/details";
// #endregion

// #region TEMPLATES
export const GetAllTemplatesEndPoint = base_url + "/api/Templates/all";
export const DownloadTemplateEndPoint = base_url + "/api/Templates/download";
export const AddTemplateEndPoint = base_url + "/api/Templates/create";
export const DeleteTemplateEndPoint = base_url + "/api/Templates";
// #endregion

// #region FORMS
export const GetFormByIdEndPoint = base_url + "/api/Forms/form/";
export const EditFormEndPoint = base_url + "/api/Forms/editForm/";
export const GetAllFormsEndPoint = base_url + "/api/Forms/getForms";
export const CreateFormEndPoint = base_url + "/api/Forms/createForm";
export const CreateSubmissionEndPoint = base_url + "/api/Forms/createSubmission";
// #endregion

// #region FORMIO FORMS
export const GetFormioFormsEndPoint = base_url + "/api/FormioForms";
export const GetFormioFormByIdEndPoint = base_url + "/api/FormioForms/"; // + formId
export const CreateFormioFormEndPoint = base_url + "/api/FormioForms";
export const UpdateFormioFormEndPoint = base_url + "/api/FormioForms/"; // + formId
export const DeleteFormioFormEndPoint = base_url + "/api/FormioForms/"; // + formId
export const CreateFormioSubmissionEndPoint = base_url + "/api/FormioForms/"; // + formId + "/submissions"
// #endregion

// #region WORKFLOWS
export const GetWorkflowsEndpoint = base_url + "/api/Workflow/GetWorkflows";
export const ClaimTaskEndPoint = base_url + "/api/Workflow/ClaimTask";
export const StartProcessByDefinitionKeyEndPoint = base_url + "/api/Workflow/StartProcessByDefinitionKey";
export const GetWorkflowTasksPendingEndPoint = base_url + "/api/WorkflowTasks/PendingTasks";
export const SearchWorkflowTasksPendingEndPoint = base_url + "/api/WorkflowTasks/PendingTasks/Search";
// Unassigned Tasks page: open tasks nobody has claimed yet, offered to the user.
export const GetWorkflowTasksUnassignedEndPoint = base_url + "/api/WorkflowTasks/UnassignedTasks";
export const SearchWorkflowTasksUnassignedEndPoint = base_url + "/api/WorkflowTasks/UnassignedTasks/Search";
export const ExecuteWorkflowTaskEndPoint = base_url + "/api/WorkflowTasks/Execute";
export const UnclaimWorkflowTaskEndPoint = base_url + "/api/WorkflowTasks/Unclaim";
export const ClaimWorkflowTaskEndPoint = base_url + "/api/WorkflowTasks/Claim";
export const DeleteWorkflowProcessEndPoint = base_url + "/api/WorkflowProcesses/Delete";
export const ProcessDocumentsEndPoint = base_url + "/api/WorkflowTasks/Documents";
export const ProcessDocumentDownloadEndPoint = base_url + "/api/WorkflowTasks/Documents/Download";
export const RegenerateProcessDocumentEndPoint = base_url + "/api/WorkflowTasks/Documents/Regenerate";
export const DocumentTemplateVersionsEndPoint = base_url + "/api/WorkflowTasks/Documents/TemplateVersions";
export const ReassignCandidatesEndPoint = base_url + "/api/WorkflowTasks/Reassign/Candidates";
export const ReassignTaskEndPoint = base_url + "/api/WorkflowTasks/Reassign";
// Workflow history page, "My processes": processes the user started or completed a task in.
export const GetMyWorkflowProcessesEndPoint = base_url + "/api/WorkflowProcesses/MyProcesses";
export const SearchMyWorkflowProcessesEndPoint = base_url + "/api/WorkflowProcesses/MyProcesses/Search";
export const CloneWorkflowProcessEndPoint = base_url + "/api/WorkflowProcesses/Clone";
export const StartWorkflowProcessEndPoint = base_url + "/api/WorkflowProcesses/Start";
export const ViewWorkflowProcessEndPoint = base_url + "/api/WorkflowProcesses/View";
export const StartProcessEndPoint = base_url + "/api/Workflow/StartProcess";
// #endregion

// #region DASHBOARDS
export const GetSupersetDashboardEndPoint = base_url + "/api/Dashboards/superset/get-dashboards";
// #endregion

// #region IMPORT DATA
export const ImportCustomDataEndPoint = base_url + "/api/Import"
// #endregion
